export default "__VITE_PUBLIC_ASSET__1a11d4b6__"